import React from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  postDepartmentApi,
  getDeparmentListApi,
  getDepartmentByIdApi,
  postDesignationApi,
  getDesignationByIdApi,
  getDesignationListApi,
  postHolidaysApi,
  getHolidaysListApi
} from '../services/Apis';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function useHrisSettings() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const initial_page = useSelector(state => state.globalslice.initial_page);
  const sorting_data = useSelector(state => state.globalslice.sorting_data);

  const postDepartment = useMutation({
    mutationFn: (formData) => postDepartmentApi(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries(['department']);
    },
    onError: (error) => {
      console.error('Department add failed:', error);
    },
  });

  const getDeparmentList = (perPage) => {
    return useQuery({
      queryKey: ['department', {
        page: initial_page,
        limit: perPage,
        sort: sorting_data.sortBy,
        order: sorting_data.sortOrder,
        search: sorting_data.search
      }],
      queryFn: () => getDeparmentListApi({
        page: initial_page,
        limit: perPage,
        sort: sorting_data.sortBy,
        order: sorting_data.sortOrder,
        search: sorting_data.search
      }),
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  };

  const getDepartmentById = (id) => {
    return useQuery({
      queryKey: ['departmentbyid', { id }],
      queryFn: () => getDepartmentByIdApi(id),
      enabled: !!id,
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  };

  const postDesignation = useMutation({
    mutationFn: (formData) => postDesignationApi(formData),
    onSuccess: (data) => {
      console.log("Designation Added:", data);
      queryClient.invalidateQueries(['designation']);
    },
    onError: (error) => {
      console.error('Designation add failed:', error);
    },
  });

 
  const getDesignationList = (perPage) => {
    return useQuery({
      queryKey: ['designation', {
        page: initial_page,
        limit: perPage,
        sort: sorting_data.sortBy,
        order: sorting_data.sortOrder,
        search: sorting_data.search
      }],
      queryFn: () => getDesignationListApi({
        page: initial_page,
        limit: perPage,
        sort: sorting_data.sortBy,
        order: sorting_data.sortOrder,
        search: sorting_data.search
      }),
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  };

  const getDesignationById = (id) => {
    return useQuery({
      queryKey: ['designationbyid', { id }],
      queryFn: () => getDesignationByIdApi(id),
      enabled: !!id,
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  };

  // HOLIDAYS
  const postHolidays = useMutation({
    mutationFn: (formData) => postHolidaysApi(formData),
    onSuccess: (data) => {
      console.log("Holiday Added:", data);
      queryClient.invalidateQueries(['holidays']);
    },
    onError: (error) => {
      console.error('Holidays add failed:', error);
    },
  });

  // HOLIDAYS LIST
  const getHolidaysList = (perPage) => {
    return useQuery({
      queryKey: ['holidays', {
        page: initial_page,
       limit: perPage,
        sort: sorting_data.sortBy,
        order: sorting_data.sortOrder,
        search: sorting_data.search
      }],
      queryFn: () => getHolidaysListApi({
        page: initial_page,
      limit: perPage,
        sort: sorting_data.sortBy,
        order: sorting_data.sortOrder,
        search: sorting_data.search
      }),
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  };

  return {
    postDepartment,
    getDeparmentList,
    getDepartmentById,
    postDesignation,
    getDesignationList,
    getDesignationById,
    postHolidays,
    getHolidaysList,
  };
}